import React, { useEffect, useState } from "react";

import InputField from "../../../../common/InputField";
import * as Yup from "yup";

import { Form, Formik } from "formik";
import { Typography, Box, Container } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../../common/Buttons";
import {
  getGuardianOridinance,
  postGuardianOridinance,
} from "../../../../services/documentServices";
import { toast } from "react-hot-toast";
import { getUserDetailProfile } from "../../../../services/user/UserServices";
import { FormHeading, setStepStatus } from "../../../../utils/Utilities";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Circles } from "react-loader-spinner";

const validate = (t) => {
  return Yup.object({
    name: Yup.string().max(50, t("max-50-characters")),
    street: Yup.string().matches(/^[a-zA-Z-.äöüÄÖÜß ]*$/g, t("validation-p1")),
    houseNumber: Yup.string(),
    city: Yup.string(),
    postalCode: Yup.number()
      .positive(t("postalCode-positive"))
      .test(
        "len",
        t("max-5-characters"),
        (val) => !val || (val && val.toString().length === 5)
      )
      .nullable(),
    email: Yup.string().email(t("Must-be-ValidEmail")),
    dateOfBirth: Yup.string(),

    phone: Yup.number(t("must-be-number"))
      .min(0, t("must-be-positive"))
      .typeError(t("in-valid"))
      .test(
        "len",
        t("less-than-15"),
        (val) => !val || (val && val.toString().length <= 15)
      ),
  });
};

const GetStarted = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [initialValues, setInitialValues] = useState({
    name: "",
    street: "",
    houseNumber: "",
    city: "",
    postalCode: "",
    email: "",
    dateOfBirth: "",
    phone: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  async function fetchData() {
    props.setButtonDisabled(true);
    setIsLoading(true);
    try {
      const result = await getGuardianOridinance(id);
      if (result?.success && result?.payLoad) {
        setData(result.payLoad);
        if (
          result.payLoad.guardianDetermineDetail !== null &&
          result.payLoad.guardianDetermineDetail?.stepStatus !== 0
        ) {
          const { dateOfBirth, ...rest } =
            result.payLoad.guardianDetermineDetail;
          setInitialValues({ ...rest, dateOfBirth: dateOfBirth?.slice(0, 10) });
        }
      } else {
        let userData = await getUserDetailProfile(id);
        if (userData?.success) {
          setInitialValues({
            name:
              userData?.payLoad.firstName + " " + userData?.payLoad.lastName,
            email: userData?.payLoad.email,
            phone: userData?.payLoad.phoneNumber,
            dateOfBirth: userData?.payLoad?.dateOfBirth.slice(0, 10),
            street: userData?.payLoad?.street,
            houseNumber: userData?.payLoad?.houseNumber,
            city: userData?.payLoad?.city,
            postalCode: userData?.payLoad?.postalCode,
          });
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      props.setButtonDisabled(false);
      setIsLoading(false);
    }
  }
  useEffect(() => {
    fetchData();
  }, []);
  const handleSubmit = async (values) => {
    props.setButtonDisabled(true);
    const {
      stepStatus,
      guardianDetermineDetailId,
      guardianOrdinanceId,
      dateOfBirth,
      ...rest
    } = values;
    const payload = {
      ...data,
      guardianDetermineDetail: {
        ...data?.guardianDetermineDetail,
        ...rest,
        dateOfBirth: dateOfBirth === "" ? null : dateOfBirth,
        stepStatus: setStepStatus(dateOfBirth, { ...rest }),
      },
    };
    const result = await postGuardianOridinance(payload, id);
    if (result?.success) {
      props.next();
    }
    props.setButtonDisabled(false);
  };

  const handleDateOfBirthKeyDown = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Container
        className="summary-table documents-card-height"
        sx={{ display: "flex", justifyContent: "center" }}
      >
        {isLoading ? (
          <Box component="div" className="loader-container">
            <Circles color="#dfc8db" height={80} width={80} />
          </Box>
        ) : (
          <Box sx={{ mt: 1 }} width="60%">
            <FormHeading variant="h4" color="color.magentaDark1">
              {t("gs-heading")}
            </FormHeading>
            <Typography variant="p" color="color.magentaDark1">
              {t("gs-text")}
            </Typography>
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validate(t)}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              {(formik) => {
                return (
                  <Form
                    id="form_submit"
                    onSubmit={formik.handleSubmit}
                    style={{ marginTop: "1rem" }}
                  >
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="John"
                      label={t("input-5")}
                      name="name"
                      type="text"
                    />

                    <InputField
                      fullWidth
                      InputLabelProps={{ shrink: true }}
                      variant="standard"
                      label={t("input-2")}
                      name="dateOfBirth"
                      type="date"
                      onKeyDown={handleDateOfBirthKeyDown}
                    />
                    <Box sx={{ display: "flex" }}>
                      <InputField
                        variant="standard"
                        placeholder="Turmbergstraße "
                        label={t("input-6")}
                        name="street"
                        type="text"
                      />

                      <InputField
                        sx={{ marginLeft: "20px" }}
                        variant="standard"
                        label={t("input-7")}
                        name="houseNumber"
                        type="text"
                      />
                    </Box>
                    <Box sx={{ display: "flex" }}>
                      <InputField
                        variant="standard"
                        placeholder="Karlsruhe "
                        label={t("input-8")}
                        name="city"
                        type="text"
                      />

                      <InputField
                        sx={{ marginLeft: "20px" }}
                        variant="standard"
                        label={t("input-9")}
                        name="postalCode"
                        type="number"
                      />
                    </Box>

                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="demo@gmail.com"
                      label={t("input-3")}
                      name="email"
                      type="email"
                    />
                    <InputField
                      fullWidth
                      variant="standard"
                      placeholder="2842394789"
                      label={t("input-4")}
                      name="phone"
                      type="string"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Form>
                );
              }}
            </Formik>
          </Box>
        )}
      </Container>
    </>
  );
};

export default GetStarted;
